/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    inverse: { type: 'variant', values: [ true ] },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: {
        borderBottomColor: '#2b8000',
        borderBottomWidth: 2,
        color: '#2b8000'
      }
    },
    {
      if: { focus: true },
      tokens: {
        borderBottomColor: '#2b8000',
        borderBottomWidth: 4,
        color: '#2b8000'
      }
    },
    {
      if: { pressed: true },
      tokens: {
        borderBottomColor: '#1f5c09',
        borderBottomWidth: 2,
        color: '#1f5c09'
      }
    },
    {
      if: { focus: true, pressed: true },
      tokens: { borderBottomWidth: 4 }
    },
    {
      if: { inactive: true },
      tokens: {
        borderBottomColor: '#676e73',
        borderBottomWidth: 4,
        color: '#676e73'
      }
    },
    {
      if: { selected: true },
      tokens: {
        borderBottomColor: '#676e73',
        borderBottomWidth: 4,
        color: '#676e73',
        fontName: 'HNforTELUSSA',
        fontWeight: '400'
      }
    },
    { if: { inverse: true }, tokens: { color: '#ffffff' } },
    {
      if: { hover: true, inverse: true },
      tokens: {
        borderBottomColor: '#ffffff',
        borderBottomWidth: 2,
        color: '#ffffff'
      }
    },
    {
      if: { inverse: true, pressed: true },
      tokens: {
        borderBottomColor: '#676e73',
        borderBottomWidth: 2,
        color: '#676e73'
      }
    },
    {
      if: { focus: true, inverse: true },
      tokens: {
        borderBottomColor: '#ffffff',
        borderBottomWidth: 4,
        color: '#ffffff'
      }
    },
    {
      if: { focus: true, inverse: true, pressed: true },
      tokens: {
        borderBottomColor: '#676e73',
        borderBottomWidth: 4,
        color: '#676e73'
      }
    },
    {
      if: { inverse: true, selected: true },
      tokens: {
        borderBottomColor: '#ffffff',
        borderBottomWidth: 4,
        color: '#ffffff',
        fontName: 'HNforTELUSSA',
        fontWeight: '700'
      }
    }
  ],
  tokens: {
    alignItems: 'flex-start',
    borderBottomColor: 'transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    color: '#414547',
    flex: 1,
    fontName: 'HNforTELUSSA',
    fontScaleCap: 64,
    fontSize: 14,
    fontWeight: '400',
    justifyContent: 'flex-start',
    letterSpacing: 0,
    lineHeight: 1.45,
    paddingBottom: 16,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0
  }
}
export default theme
